import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ShieldCheckIcon, LockIcon, ZapIcon, CreditCardIcon, SmartphoneIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { MoreTestimonials } from './MoreTestimonials';
const plan = {
  name: '📘 THE 360° INJURY REHAB SYSTEM™',
  ideal: 'Anyone wishing to manage injury rehabilitation from scratch, without prior clinical experience',
  was: '$38',
  now: '$19',
  features: ['6 Complete Volumes (150+ pages)', 'Shoulder, Knee, Ankle, Spine, Hip & Elbow protocols', 'Real return-to-sport frameworks', '30-Day routine with visible progress', '5 Free Bonuses included', '7-Day Money-Back Guarantee'],
  cta: 'Get The 360° Injury Rehab System'
};
const trust = [{
  icon: LockIcon,
  label: '100% Secure Payment'
}, {
  icon: ZapIcon,
  label: 'Instant Access'
}, {
  icon: CreditCardIcon,
  label: 'Credit / Debit'
}, {
  icon: SmartphoneIcon,
  label: 'Android & iOS'
}];
export function Pricing() {
  return <section id="pricing" aria-label="Pricing" className="bg-radial-glow w-full overflow-x-hidden" data-id="element-130" data-mp="3vzp5xj5hic9j">
      <div className="mx-auto w-full max-w-5xl px-5 py-12" style={{
      paddingTop: "15px",
      paddingBottom: "15px"
    }} data-id="element-131" data-mp="4svw5qwml4te">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-40px'
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto flex w-full max-w-md flex-col items-center rounded-3xl border border-grape/30 bg-white px-6 pb-7 pt-10 text-center shadow-[0_24px_60px_-28px_rgba(29,78,216,0.45)]" style={{
        paddingTop: "5px",
        paddingBottom: "5px"
      }} data-id="element-132" data-mp="9rz17bclvb1d">
          <h3 className="font-display text-lg font-black text-plum" data-id="element-133" data-mp="3n523mvv4ag1i">{plan.name}</h3>
          <p className="mt-2 text-sm text-plum/60" data-id="element-134" data-mp="3rzenh70i9tds">
            <span className="font-semibold text-plum/80" data-id="element-135" data-mp="2uiptfzhsrvey">Ideal for:</span> {plan.ideal}
          </p>

          <div className="mt-6" data-id="element-136" data-mp="2zh1061csppsy">
            <span className="text-base font-medium text-plum/40 line-through" style={{
            fontSize: "20px"
          }} data-id="element-137" data-mp="2zg9dxh5394fc">{plan.was}</span>
            <div className="text-grape-shine font-display text-4xl font-black" style={{
            fontSize: "64px",
            paddingBottom: "26px",
            fontFamily: "Montserrat, sans-serif",
            paddingTop: "20px"
          }} data-id="element-138" data-mp="2rei9qdls0fpl">{plan.now}</div>
            <p className="mt-1 text-xs font-semibold text-grape" data-id="element-139" data-mp="2w71ohdw79gvz">
              One-time payment · Lifetime access
            </p>
            <p className="mt-1 text-[11px] font-medium text-plum/50" data-id="element-140" data-mp="28is6yo60rfan">
              Payment will be processed in your local currency.
            </p>
          </div>

          <ul className="mt-6 w-full flex-1 space-y-3 text-left" data-id="element-141" data-mp="2igpuf9g21827">
            {plan.features.map(f => <li key={f} className="flex items-start gap-2.5 text-sm text-plum/80" data-id="element-142" data-mp="2dhd6eldg5uy1">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-grape" strokeWidth={3} data-id="element-143" data-mp="3tvbqvtzwe6nm" />
                {f}
              </li>)}
          </ul>

          <div className="mt-7 flex w-full justify-center" data-id="element-144" data-mp="3ov7bk7aq7hyz">
            <CTAButton size="md" data-id="element-145" data-mp="anbcf44a2p8">{plan.cta}</CTAButton>
          </div>

          <p className="mt-3 text-[11px] font-semibold text-plum/50" data-id="element-146" data-mp="cgjxzyaiwzv">
            You save $19 USD (50% OFF)
          </p>
          

          <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-xs font-medium text-plum/55" data-id="element-147" data-mp="3nfd0ot8bwv7y">
            {trust.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-148" data-mp="j0va6l0sa6zm">
                <Icon className="h-4 w-4 text-grape" data-id="element-149" data-mp="j2yabxvnhgi2" />
                {label}
              </span>)}
          </div>
        </motion.div>

        <MoreTestimonials data-id="element-150" data-mp="a8ta4nummspv" />

        <div className="mx-auto mt-12 flex w-full max-w-2xl items-start gap-3 rounded-2xl border border-grape/20 bg-white/80 p-5 text-left" data-id="element-151" data-mp="a7ibf2g1gb5m">
          <ShieldCheckIcon className="mt-0.5 h-6 w-6 shrink-0 text-grape" data-id="element-152" data-mp="e82864wp9cr8" />
          <p className="text-[15px] leading-relaxed text-plum/75" data-id="element-153" data-mp="11y6b0a22d8h6">
            <span className="font-display font-bold text-plum" data-id="element-154" data-mp="16qpkovxmrjgp">
              🛡️ 7-Day Money-Back Guarantee.
            </span>{' '}
            If within the first 7 days you feel the ebook does not match what you need or does not
            give you the boost you were looking for, request your refund and we return 100% of your
            money. We want you to rehabilitate with peace of mind, risk-free.
          </p>
        </div>
      </div>
    </section>;
}